import { render, staticRenderFns } from "./FullMember.vue?vue&type=template&id=96a2f850&"
import script from "./FullMember.vue?vue&type=script&lang=js&"
export * from "./FullMember.vue?vue&type=script&lang=js&"
import style0 from "./FullMember.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FullMember.vue"
export default component.exports